import { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
//import * as helpers from 'utilities/helpers';

// routes
import Routes from './routes';

import 'react-toastify/dist/ReactToastify.css';

import { useOpenConfig } from 'utilities/variables/openConfigContext';

const App: React.FC = () => {

  const [isMobile, setIsMobile] = useState(false);
  const [isMobileEnabled, setIsMobileEnabled] = useState(false);
  
  document.title = ''

  const { config } = useOpenConfig();
  
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    
    if (config) {
      
      const favicon = document.getElementById('favicon') as HTMLLinkElement;

      if (favicon) {
        if ( config.BRANDING === 'GENERIC') {
          favicon.href = process.env.PUBLIC_URL + '/favicon-standard.png'
        } else if (config.BRANDING === 'KURO') {
          favicon.href = process.env.PUBLIC_URL + '/favicon-other.png';
        } else {
          favicon.href = process.env.PUBLIC_URL + ''
        }
      }

      if ( config.BRANDING === 'GENERIC') {
        document.title = 'Intelligent Cloud'
      } else if (config.BRANDING === 'KURO') {
        document.title = 'Kuro'
      } else {
        document.title = ''
      }

      if ( config.MOBILEINTERFACE  && config.MOBILEINTERFACE === true) {
        setIsMobileEnabled(true);
      } else {
        setIsMobileEnabled(true);
      }
    }

    const handleResize = () => {
      const userAgent = navigator.userAgent;
      const isMobileDevice = /android|iPad|iPhone|iPod/i.test(userAgent);
      setIsMobile(isMobileDevice);
    };

    handleResize(); // Check the initial width and user agent
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  useEffect(() => {
    // Dynamically import the correct SCSS once we know device type
    if (isMobile) {
      import('./mobile/assets/scss/style.scss');
      
    } else {
      import('./assets/scss/theme.scss');
    }
  }, [isMobile]);

  return (
    <>
      <ToastContainer
        style={{ zIndex: '1000000' }} // Above current nav z-index 
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={'light'}
      />
      <Routes mobile={isMobile} mobileEnabled={isMobileEnabled} />
    </>
  );
};

export default App;
